const login = () => import(/* webpackPrefetch: true */ '@/views/public/index.vue')

const routes = [
  {
    path: "/login",
    name: "login",
    component: login,
    meta: {
      title: "Masuk"
    }
  }
]
export default routes.map(route => {
  const meta = {
    all: false, 
    public: true,
    onlyLoggedOut: true,
    title: route.meta.title
  }
  return { ...route, meta }
})